import { CA } from 'src/app/shared/entities/ca';

export enum ExpirationStatus {
  Active = 'Active',
  Expired = 'Expired',
  Unknown = 'Unknown', // what if a CA doesn't have expiryTime?
}

export enum NearExpirationCategory {
  expired = 'expired',
  sixMonths = 'sixMonths',
  oneYear = 'oneYear',
  overOneYear = 'overOneYear',
}

interface TimeSpan {
  years?: number;
  months?: number;
  days?: number;
}

function addTimeSpan(date: Date, timeSpan: TimeSpan): Date {
  const result = new Date(date);
  result.setFullYear(date.getFullYear() + (timeSpan.years ?? 0));
  result.setMonth(date.getMonth() + (timeSpan.months ?? 0));
  result.setDate(date.getDate() + (timeSpan.days ?? 0));
  return result;
}

const MAX_EXPIRATION_FROM_NOW: Record<NearExpirationCategory, TimeSpan> = {
  [NearExpirationCategory.expired]: { days: 0 },
  [NearExpirationCategory.sixMonths]: { months: 6 },
  [NearExpirationCategory.oneYear]: { years: 1 },
  [NearExpirationCategory.overOneYear]: { years: Number.POSITIVE_INFINITY },
};

export function caExpirationStatus(ca: CA): ExpirationStatus {
  const now = Date.now();
  const expireTime = ca.expireTime;
  if (expireTime === null || expireTime === undefined) {
    return ExpirationStatus.Unknown;
  }
  return expireTime > now ? ExpirationStatus.Active : ExpirationStatus.Expired;
}

export function caNearExpirationCategory(ca: CA): NearExpirationCategory {
  const now = new Date();
  const categories = Object.values(NearExpirationCategory)
    .map(category => ({
      category,
      maxExpireTime: addTimeSpan(
        now,
        MAX_EXPIRATION_FROM_NOW[category],
      ).getTime(),
    }))
    .sort((c1, c2) => c1.maxExpireTime - c2.maxExpireTime);
  const expireTime = ca.expireTime ?? 0;
  return (
    categories.find(({ maxExpireTime }) => expireTime < maxExpireTime) ??
    categories[categories.length - 1]
  ).category;
}

export enum CACol {
  caName = 'caName',
  status = 'status',
  expiry = 'expiry',
}
